export interface RRGarmentFileListModel {
  filename: string;
  download_url: string;
}
